import config from '@/utils/Config'
import {get, post } from '@/utils/request'

export function getQsList(params = { id: id, lifeId: lifeId, pageNo: pageNo, pageSize: pageSize }) {
    return get(config.BASE_URL, config.getQsListUrl, params)
}

export function saveCommentsData(params = {}) {
    return post(config.BASE_URL, config.saveCommentsUrl, params)
}

export function getRecentQsList(params = {}) {
    return get(config.BASE_URL, config.getRecentQsListUrl, params)
}

export function getAdminCommentList(params = {}) {
    return post(config.BASE_URL, config.getAdminCommentListUrl, params)
}

export function delComment(params = { id: id }) {
    return post(config.BASE_URL, config.delCommentUrl, params)
}